import {lazy} from './lang.js';
import {dot, dash} from '../tidal/parser.js';
const make = (term, type) => ({... term, transpose:0,
                               type});

export const t_double = (figure) => {
  return (...args) => {
    let _figure = lazy(figure, ...args);
    let doubled = [];
    for (let i=0; i < _figure.length; i++) {
      let term = _figure[i];
      let {
        type, value
      } = term.type;
      if (type === '.') {
        // dot becomes dash bracked
        doubled.push([
          make(term, dash(0)),
          make(term, dash(1))
          ]);
      } else {
        // dash becomes . . -
        let list = [
        make(term, dot()),
        make(term, dot()),
        make(term, dash(0)),
        make(term, dash(1))
        ];
        list.cycleLength = 2;
        doubled.push(list);
        // skip next one since its gonna be dash(1)
        i++;
      }
      
    }
    return doubled;
  };
};
